var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDragIndicator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5882 11.1998C20.5882 12.9671 19.1135 14.3999 17.2942 14.3999C15.4749 14.3999 14 12.9671 14 11.1998C14 9.43253 15.4749 8 17.2942 8C19.1135 8 20.5882 9.43253 20.5882 11.1998Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5882 23.9999C20.5882 25.7672 19.1135 27.2 17.2942 27.2C15.4749 27.2 14 25.7672 14 23.9999C14 22.2326 15.4749 20.7998 17.2942 20.7998C19.1135 20.7998 20.5882 22.2326 20.5882 23.9999Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5882 36.8002C20.5882 38.5675 19.1135 40 17.2942 40C15.4749 40 14 38.5675 14 36.8002C14 35.0329 15.4749 33.6001 17.2942 33.6001C19.1135 33.6001 20.5882 35.0329 20.5882 36.8002Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34 11.1998C34 12.9671 32.5251 14.3999 30.7058 14.3999C28.8865 14.3999 27.4118 12.9671 27.4118 11.1998C27.4118 9.43253 28.8865 8 30.7058 8C32.5251 8 34 9.43253 34 11.1998Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34 23.9999C34 25.7672 32.5251 27.2 30.7058 27.2C28.8865 27.2 27.4118 25.7672 27.4118 23.9999C27.4118 22.2326 28.8865 20.7998 30.7058 20.7998C32.5251 20.7998 34 22.2326 34 23.9999Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34 36.8002C34 38.5675 32.5251 40 30.7058 40C28.8865 40 27.4118 38.5675 27.4118 36.8002C27.4118 35.0329 28.8865 33.6001 30.7058 33.6001C32.5251 33.6001 34 35.0329 34 36.8002Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragIndicator);
export default __webpack_public_path__ + "static/media/drag-indicator.ca39e16d.svg";
export { ForwardRef as ReactComponent };